import React, { useState } from 'react';
import { LegendaryPokemon } from './LegendaryPokemon';
export function NewsUpdates() {
  const [isOpen, setIsOpen] = useState(false);
  const newsItems = [{
    id: 1,
    title: 'Shiny Ruins Pokémon Available Now!',
    content: "You can now obtain a shiny version of each ruins Pokémon through Mystery Gift, and you don't need any DLC or special requirements. The time limit for this gift ends on Tuesday, September 30th, 2025. Get them while you can!"
  }, {
    id: 2,
    title: 'Shiny Koraidon and Miraidon Available Now!',
    content: "Shiny Koraidon and Miraidon are now available in shiny form! Visit your local GameStop to get a card listing a mystery gift code, OR if you don't live near one, use one of the YouTube live giveaways listed in that section. The GameStop event lasts until October 6th, 2025. Get them while you can!",
    image: 'https://www.pokemon.com/static-assets/content-assets/cms2/img/video-games/_tiles/pokemon-scarlet-violet/distributions/shiny-koraidon-shiny-miraidon/scarlet-violet-169-en.png'
  }];
  return <section className="bg-slate-800/70 rounded-lg p-6 backdrop-blur-sm border border-slate-700 shadow-lg" data-id="element-175">
      <div className="flex items-center justify-between mb-4" data-id="element-176">
        <button className="w-full flex items-center justify-between bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-177">
          <span className="text-xl" data-id="element-178">Pokémon News & Updates</span>
          <svg className={`w-6 h-6 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-179">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-180"></path>
          </svg>
        </button>
        <div className="ml-4" data-id="element-181">
          <LegendaryPokemon data-id="element-182" />
        </div>
      </div>
      {isOpen && <div className="space-y-4 mt-4 p-2 bg-slate-700/60 rounded-lg" data-id="element-183">
          {newsItems.map(item => <div key={item.id} className="bg-slate-700/60 rounded-lg p-4 border border-slate-600 shadow-md" data-id="element-184">
              <div className="mb-2" data-id="element-185">
                <h3 className="text-xl font-semibold text-yellow-300" data-id="element-186">
                  {item.title}
                </h3>
              </div>
              {item.image && <div className="mb-3" data-id="element-187">
                  <img src={item.image} alt={item.title} className="w-full rounded-lg shadow-sm" data-id="element-188" />
                </div>}
              <p className="text-gray-200" data-id="element-189">{item.content}</p>
            </div>)}
        </div>}
    </section>;
}